exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-checkbox-container{display:inline-block}.form-checkbox-input{position:absolute;left:0;top:5px;height:0;width:0;opacity:0}.form-checkbox-label{display:inline-block;position:relative;float:left;margin:10px 15px 10px 0;padding-left:50px;padding-top:10px;font-size:.875rem;line-height:1.25rem;cursor:pointer}.form-checkbox-label:before{display:inline-block;position:absolute;left:0;top:0;width:40px;height:40px;content:\" \";background-color:#fff;border:1px solid #545454}.form-checkbox-input:focus+.form-checkbox-label:before{border:2px solid #545454}.form-checkbox-input:checked+.form-checkbox-label:before{background:url(" + require("./checkbox-green.png") + ") no-repeat 50%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/form/FormCheckbox/FormCheckbox.scss
 ** module id = 1239
 ** module chunks = 0
 **/